import React from 'react';
import styled from 'styled-components';
import { Trans } from '@lingui/react';
import { FormHelper } from '@components/texts';

const Element = styled.textarea`
  width: 100%;
  min-height: 140px;
  border-radius: 5px;
  border: solid 1px #dddddd;
  padding: 11px;
  outline: 0;
  resize: none;
  font-size: 16px;

  &:disabled {
    background-color: #f7f7f7;
  }

  &:focus {
    border: 1px solid #129edc;
  }

  /** Placeholder **/
  &::-webkit-input-placeholder {
    font-size: 13px;
    color: #c7c7c7;
  }

  &:-moz-placeholder {
    /* Firefox 18- */
    font-size: 13px;
    color: #c7c7c7;
  }

  &::-moz-placeholder {
    /* Firefox 19+ */
    font-size: 13px;
    color: #c7c7c7;
  }

  &:-ms-input-placeholder {
    font-size: 13px;
    color: #c7c7c7;
  }

  ${props => props.maxLengthError && `border: 1px solid red;`};
`;

const TextArea = props => {
  return (
    <React.Fragment>
      <Element
        className={props.className}
        name={props.name}
        id={props.id}
        onChange={props.onChange}
        onBlur={props.onBlur}
        placeholder={props.placeholder}
        value={props.value}
        maxLength={props.maxLength}
        maxLengthError={props.value && props.value.length >= props.maxLength}
        disabled={props.disabled}
        cols={props.cols}
        rows={props.rows}
      />
      {props.value && props.value.length >= props.maxLength ? (
        <FormHelper>
          <Trans
            id="errors.maxlength"
            message={`You can't have more than {length} characters`}
            values={{ length: props.maxLength }}
          />
        </FormHelper>
      ) : null}
    </React.Fragment>
  );
};

export default TextArea;
